import { useContext, useMemo, useState } from "react";
import { Position } from "reactflow";
import CodeBlockIcon from "../../assets/images/codeBlockIcon.svg";
import NodeContext from "../../context/NodeContext";
import {
  ActionButtonContainer,
  CodeBlockNode as StyledCodeBlockNode,
} from "./CodBlockNode.styled";
import DeleteIconImg from "../../assets/images/deleteIcon.svg";
import AddNodeSelector from "../../components/AddNodeSelector";
import { BottomEdge, TopEdge } from "../StartingNode/StartingNode.styled";
import { Button } from "../../components/ui/button";

function CodeBlockNode(props) {
  const { id, data } = props;
  const { titleText, isTop, isBottom } = data;
  const { handleNodeClick, edges, deleteNode, selectedNodeInfo, isEditable, active, isSuperAdmin, setSuperAdminModalVisibility } =
    useContext(NodeContext);
  const [showAddBox, setShowAddBox] = useState(false);
  const [visible, setVisible] = useState(false);

  const isBottomEdgeConnected = useMemo(
    () =>
      edges.findIndex(
        (edge) => edge.source === id && edge.sourceHandle === "bottom"
      ) !== -1,
    [edges, id]
  );

  return (
    <>
      {isTop ? (
        <TopEdge
          type="target"
          position={Position.Top}
          id="top"
          isConnectable={true}
          iseditable={isEditable ? "true" : undefined}
        />
      ) : null}

      <StyledCodeBlockNode
        $isActive={active ? active : selectedNodeInfo?.id === id}
        onClick={() => handleNodeClick(id)}
      >
        <div className="titleContainer">
          <img src={CodeBlockIcon} alt="codeBlockIcon" />
          <span className="titleText">{titleText}</span>
        </div>

        {(isEditable) && <ActionButtonContainer
          className="action-btns"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={DeleteIconImg}
            alt="deleteIcon"
            onClick={() => {
              //   deleteNode(id);
              setVisible(true);
            }}
          />
        </ActionButtonContainer>}
        {(isEditable) && visible && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
            style={{
              right: "-315px",
              top: "-35px",
              height: "auto",
              width: "250px",
              padding: "10px",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Plus Jakarta Sans, sans-serif",
                marginBottom: "10px",
                color: "#000",
              }}
            >
              Are you sure you want to delete?
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "150px",
                margin: "auto",
                padding: "10px 8px",
                gap: "20px",
              }}
            >
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#007372] text-[#007372] hover:bg-teal-50 hover:text-[#007372] hover:border-[#007372]"
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#ef4949] text-[#ef4949] hover:bg-red-50 hover:text-[#ef4949] hover:border-[#ef4949]"
                onClick={() => {
                  setVisible(false);
                  if (!isSuperAdmin) {
                    setSuperAdminModalVisibility({
                      visible: true,
                      id: id,
                    });
                  } else {
                    deleteNode(id);
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </ActionButtonContainer>
        )}


        {showAddBox ? (
          <AddNodeSelector nodeData={props} setShowAddBox={setShowAddBox} />
        ) : null}
      </StyledCodeBlockNode>

      {isBottom ? (
        <BottomEdge
          type="source"
          position={Position.Bottom}
          id="bottom"
          isConnectable={!isBottomEdgeConnected}
          onClick={(e) => {
            e.stopPropagation();
            handleNodeClick(id);
            setShowAddBox(!showAddBox);
          }}
          iseditable={isEditable ? "true" : undefined}
        />
      ) : null}
    </>
  );
}

export default CodeBlockNode;
